<template>
  <div>
    <div class="common-style">
      <div class="query">
        <div class="query-list">
          <p style="font-weight:bold;cursor:auto;">学段：</p>
          <p :class="{ liContent: stage == '0' }" @click="changeStage(0)">全部</p>
          <p
            :class="{ liContent: index == stage }"
            class="unclickable"
            v-for="(item, index) in stagesList"
            :key="index"
            @click="changeStage(index)"
          >{{ item }}</p>
        </div>
        <div class="query-list">
          <p style="font-weight:bold;cursor:auto;">学科：</p>
          <p :class="{ liContent: subject == '0' }" @click="changeSubject(0)">全部</p>
          <p
            :class="{ liContent: index == subject }"
            v-for="(item, index) in subjectsList"
            :key="index"
            @click="changeSubject(index)"
          >{{ item }}</p>
        </div>
        <div class="query-list" :class="expand ? 'show' : 'hidde'" style="border-bottom:none;">
          <p style="font-weight:bold;cursor:auto;">版本：</p>
          <p :class="{ liContent: version == '0' }" @click="changeVersion(0)">全部</p>
          <p
            ref="bussinessTypeRef"
            :class="{ liContent: index == version }"
            v-for="(item, index) in versionsList"
            :key="index"
            @click="changeVersion(index)"
          >{{ item }}</p>
        </div>
        <p class="shrink" @click="expand = !expand">
          {{ expand ? "收起" : "展开" }}
          <a-icon :type="expand ? 'up' : 'down'" />
        </p>
      </div>
      <div class="teach-list">
        <ul v-if="!noData">
          <li class="lifirstAdd" @click="toModify(false)">+添加课本</li>
          <li v-for="(item, index) in bookList" :key="index">
            <div @click="toModify(true, item)">
              <div>
                <img :src="item.readCoverUrl" />
              </div>
              <div class="dv dv1">
                <a-tooltip>
                  <template slot="title">{{ item.name }}</template>
                  <i>{{ item.name }}</i>
                </a-tooltip>
              </div>
              <div class="dv dv2">
                <!-- <a-tooltip> 
                  <template slot="title">{{item.dirurl}}</template>
                  <i>{{item.dirurl}}</i>
                </a-tooltip>-->
              </div>
            </div>
            <div class="dv dv3">
              <p v-if="item.pubdate != null">{{ item.pubdate.substring(0, 10) }}</p>
            </div>
          </li>
        </ul>
        <div v-if="noData" class="noData">
          <p>
            <img src="../../assets/images/noData.png" alt />
          </p>
          <div @click="toModify(false)">添加课本</div>
        </div>
      </div>
      <!-- 分页 -->
      <div style="margin:20px;" v-if="paginShow">
        <a-pagination
          size="small"
          :total="rowCount"
          :showTotal="(total) => `总 ${total} 份`"
          :pageSize.sync="pagination.pageSize"
          v-model="pagination.page"
          @change="onChange"
        />
      </div>
      <!-- 刷新 -->
      <div class="loada" v-if="loadingList">
        <a-spin />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data () {
    return {
      stage: 3,
      subject: 1,
      version: 0,
      stagesList: [],
      subjectsList: [],
      versionsList: [],
      expand: false,
      bookList: [],
      rowCount: "",
      loadingList: true,
      pagination: {
        page: 1,
        pageSize: 11,
      },
      paginShow: false,
      noData: true,
    }
  },
  watch: {
    expand: function () {
      this.$nextTick(function () {
        let cur = this.$refs["bussinessTypeRef"]
        if (cur) {
          // this.bussinessHeight = cur[0].clientHeight;
        }
      })
    },
  },
  methods: {
    // 学段联动接口
    getAllselect () {
      this.loadingList = true
      this.pagination.page = 1
      this.$http
        .get("v1/learnonly/teachingAssistant/showVerGreSubSta", {
          params: {
            userid: this.$store.getters.id,
            subjectid: this.subject,
            stageid: this.stage,
          },
        })
        .then((response) => {
          console.log(response)
          this.stagesList = response.data.stage
          this.subjectsList = response.data.subject
          this.versionsList = response.data.versions
          // if (response.data.data === null) {
          //   this.getAllselect((this.subject = 0))
          // }
          this.$nextTick(() => {
            this.getBooklist()
          })
        })
    },
    changeStage (index) {
      this.stage = index
      this.getAllselect()
    },
    changeSubject (index) {
      this.subject = index
      this.getAllselect()
    },
    changeVersion (index) {
      this.version = index
      this.getAllselect()
    },
    // 获取书本列表
    getBooklist () {
      this.$http
        .get("v1/elecbook/list", {
          params: {
            stageid: this.stage,
            subjectid: this.subject,
            textbookversionid: this.version,
            page: this.pagination.page,
            size: this.pagination.pageSize,
          },
        })
        .then((response) => {
          console.log(response)

          if (response.data.data.length !== 0) {
            this.bookList = response.data.data.books
            this.rowCount = response.data.data.length
            this.loadingList = false
            this.noData = false
            this.$nextTick(() => {
              this.paginShow = true
            })
          } else {
            this.loadingList = false
            this.noData = true
            this.paginShow = false
          }
        })
    },
    // 分页
    onChange (page, pageSize) {
      this.pagination.page = page
      this.pagination.pageSize = pageSize
      this.getBooklist()
    },
    // 新增教辅
    toModify (state, item) {
      console.log(item)
      if (state) {
        //   编辑
        this.$router.push({
          path: "/textbook/addTextbook",
          query: { type: true, books: JSON.stringify(item) },
        })
      } else {
        //   新增
        this.$router.push({
          path: "/textbook/addTextbook",
          query: {
            type: false,
          },
        })
      }
    },
    // // 查看教辅目录详情
    // toContent(item) {

    // }
  },
  mounted () {
    // if (this.$store.getters.orgid == 0) {
    //     this.state = 1
    // } else {
    //     this.state = 2
    // }

    // ===========
    // this.stage = this.$store.getters.stageMessage.stageids
    //   ? this.$store.getters.stageMessage.stageids[0]
    //   : 0;
    // this.subject = this.$store.getters.stageMessage.subjectids
    //   ? this.$store.getters.stageMessage.subjectids[0]
    //   : 0;
    if (this.$store.getters.stageInfoList.length > 0) {
      this.stage = this.$store.getters.stageInfoList[0].stageid
      if (this.$store.getters.stageInfoList[0].subjectids.length > 0) {
        this.subject = this.$store.getters.stageInfoList[0].subjectids[0]
      }
    } else {
      this.stage = 0
      this.subject = 0
    }
    this.getAllselect()
  },
}
</script>

<style scoped>
/*  */
.query {
  padding: 10px 20px 0 25px;
  border-bottom: 8px solid #f0f2f5;
}
.query-list {
  overflow: hidden;
  padding: 10px 55px 0 0;
  border-bottom: 1px dashed #ddd;
}
.query-list p {
  float: left;
  padding: 2px 8px;
  cursor: pointer;
  margin-bottom: 5px;
}
.query-list .liContent {
  background: #40a9ff;
  color: #fff;
  border-radius: 5px;
}
/* .query-list .unclickable:nth-child(3) {
    pointer-events: none;
    color: rgba(0, 0, 0, 0.3);
}
.query-list .unclickable:last-child {
    pointer-events: none;
    color: rgba(0, 0, 0, 0.3);
} */
.show {
  height: auto;
}
.hidde {
  height: 43px;
}
.shrink {
  position: absolute;
  top: 182px;
  font-size: 15px;
  right: 2%;
  color: #40a9ff;
  padding-right: 10px;
  cursor: pointer;
}
.teach-list {
  margin: 30px 0 0 20px;
}
.teach-list ul {
  overflow: hidden;
}
.teach-list .lifirstAdd {
  height: 262px;
  line-height: 260px;
  border: 1px dashed #ddd;
  cursor: pointer;
  text-align: center;
}
.teach-list li {
  float: left;
  margin: 0 1% 15px 0;
  border: 1px solid #eee;
  width: 15%;
  min-height: 122px;
  cursor: pointer;
}
.teach-list li:hover {
  border-color: rgba(0, 0, 0, 0.09);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
}
.teach-list li img {
  width: 100%;
  height: 174px;
}
.teach-list li .dv {
  padding: 0 10px;
}
.teach-list li .dv1 {
  padding-top: 10px;
  width: 100%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teach-list li .dv1 i {
  font-weight: bold;
}
.teach-list li .dv2 {
  font-size: 13px;
  padding-bottom: 27px;
  padding-bottom: 10px;
  color: #999;
  width: 100%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teach-list li .dv3 {
  font-size: 12px;
  color: #999;
}
.teach-list li .dv3 p {
  float: left;
}
.teach-list li .dv3 .pImg {
  float: right;
}
.teach-list li .dv3 img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: -8px;
}
/* 刷新 */
.loada {
  position: fixed;
  overflow: auto;
  top: 388px;
  right: 0;
  bottom: 0;
  left: 200px;
  z-index: 99;
  outline: 0;
  background: rgb(255, 255, 255, 0.3);
}
.ant-spin-spinning {
  padding-top: 60px;
  padding-left: 50%;
}
</style>
